import {address} from './address';
import {asm} from './asm';
import {cart} from './cart';
import {checkout} from './checkout';
import {common} from './common';
import {myAccount} from './my-account';
import {payment} from './payment';
import {product} from './product';
import {leadForm} from './lead-form';
import {pwa} from './pwa';
import {storeFinder} from './store-finder';
import {user} from './user';
import {userMenu} from './user-menu';
import {search} from './search';
import {categories} from './categories';
import {footer} from './footer';
import {homepage} from './homepage';
import {help} from './help';
import {header} from './header';
import {access} from './access';
import {orderReview} from '../en/order-review';
import {registration} from './registration';
import {ctaForm} from './cta-form';

export const de: {[chunkName: string]: {[key: string]: any;};} = {
  address,
  asm,
  cart,
  categories,
  checkout,
  common,
  footer,
  help,
  homepage,
  leadForm,
  myAccount,
  payment,
  product,
  pwa,
  search,
  storeFinder,
  user,
  userMenu,
  header,
  access,
  orderReview,
  registration,
  ctaForm
};
